import {
  orderTriplePlayV2,
  PageLayout,
  ProductType,
} from '@kizi/comparator-core';
import customerHelpContent from '../widgets/helpContent/customerHelpContent';
import uspDesktop from '../widgets/Usp/uspDesktop';
import uspMobile from '../widgets/Usp/uspMobile';
import { constructOrderVariables } from '../../../utils/order';

const applyLayout: PageLayout = {
  name: 'apply',
  localState: {
    wizardSteps: [],
    productId: undefined,
    pageError: '',
  },
  components: [
    {
      type: 'PageLayout',
      props: {
        bg: 'second.2',
        header: [
          {
            type: 'PageHeader',
            props: {
              steps: [
                { title: 'Vergelijken' },
                { title: 'Aanvragen', disabled: true },
              ],
              helpContent: customerHelpContent,
              activeStep: 1,
            },
          },
        ],
        sideNav: [
          {
            type: 'ProductSummaryWrapper',
            props: {
              display: ['none', null, 'block'],
              mb: 6,
              selectedProduct: 'overview.selectedProduct',
              type: 'energy',
            },
          },
          {
            type: 'CustomerBenefit',
          },
          uspDesktop,
          {
            type: 'Div',
            props: {
              boxShadow: 'default',
              borderRadius: 2,
              padding: 6,
              backgroundColor: 'main.0',
              marginTop: 6,
            },
            _children: [
              {
                type: 'HowItWorksWrapper',
                props: {
                  selectedProduct: 'overview.selectedProduct',
                  title: 'Zo werkt je aanvraag',
                },
              },
            ],
          },
        ],
        subHeader: [
          {
            type: 'ProductSummaryWrapper',
            props: {
              display: ['block', null, 'none'],
              mt: 4,
              mb: 0,
              selectedProduct: 'overview.selectedProduct',
              type: 'energy',
              saveForLater: false,
            },
          },
          {
            type: 'Div',
            props: {
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            },
            _children: [
              {
                type: 'Heading',
                props: {
                  variant: 'H2',
                  as: 'h2',
                  children: 'Aanvragen',
                },
              },
            ],
          },
        ],
        content: [
          {
            type: 'CommentWithAvatar',
            props: {
              mb: 7,
              avatar: {
                url: 'https://comparators.kizi.nl/cb/assets/images/3p-advisor.png',
                name: 'Stefan Vrijdag',
                role: 'Expert Internet & TV',
              },
              comment:
                'Vul je gegevens verder in en bevestig je aanvraag. Na ongeveer 2 weken krijg je het contract van de aanbieder thuisgestuurd. Vervolgens is de aansluiting binnen 4 tot 6 weken voltooid. We zorgen ervoor dat je huidige abonnement stop wordt gezet. In de tussentijd kun je gebruikmaken van je huidige verbinding.',
              commentTitle: 'Je bent bijna klaar',
            },
          },
          {
            type: 'Div',
            props: { px: 6, fontSize: 2, variant: 'primaryContainer' },
            _children: [
              {
                type: 'GoToButtonIcon',
                props: {
                  variant: 'transparentWithIcon',
                  index: 1,
                  children: 'Terug naar overzicht',
                },
              },
              {
                type: 'DynamicForm',
                props: {
                  wizardStepsKey: 'apply.wizardSteps',
                  frontEndName: 'overstappen',
                  clientName: 'consumentenbond',
                  postQuery: orderTriplePlayV2,
                  postOrderDataKey: 'fields',
                  constructOrderVariables,
                  postOrderIdPath: 'data.addTriplePlayOrderV2.orderId',
                  postOrderUrl: `${process.env.KIZI_PUBLIC_DOMAIN}/triple-play/graphql`,
                  injectedFields: {
                    'global.isMember': 'consumentenbond-userIsMember',
                    'global.cbLoggedIn': 'consumentenbond-userWasAlreadyMember',
                    'global.isWaitingForCbApiResponse': 'currentlyChecking',
                    '*.userid': 'consumentenbond-userId',
                    '*.houseNumberWithAddition': 'field_156',
                    '*.housenumberaddition': 'housenumberaddition',
                    '*.postcode': 'field_155',
                    '*.city': 'field_159',
                    '*.street': 'field_158',
                    '*.birthdate': 'birthDate',
                  },
                },
              },
              {
                type: 'RetentionDisclaimer',
                props: {
                  field: 'overview.selectedProduct',
                },
              },
              {
                type: 'ApplyFormFooterWrapper',
                props: {
                  productFieldName: 'overview.selectedProduct',
                  productType: ProductType.TRIPLEPLAY,
                },
              },
            ],
          },
          uspMobile,
          {
            type: 'AfterTheSwitchWrapper',
            props: {
              display: ['block', null, 'none'],
              mt: 6,
              mb: 7,
              title: 'Zo werkt je aanvraag',
              productFieldName: 'overview.selectedProduct',
              variant: 'afterTheSwitchApply',
            },
          },
        ],
      },
    },
  ],
};

export default applyLayout;
